import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { defineComponent, ref, computed, watch } from "vue";
import ImageCompareVue from "@/components/ImageCompare.vue";
import NavbarVue from "@/components/Navbar.vue";
import MenuLeftVue from "@/components/MenuLeft.vue";
import { setFloorPattern, setModal, setWallColor, buildTreatedImageUrl } from "@/core/helpers/config";
import ModalLoader from "../components/modals/ModalLoader.vue";
import MenuBottom from "@/components/MenuBottom.vue";
import MenuMobile from "@/components/MenuMobile.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ElNotification } from "element-plus";
export default defineComponent({
  name: "Home",
  components: {
    ImageCompareVue: ImageCompareVue,
    NavbarVue: NavbarVue,
    MenuLeftVue: MenuLeftVue,
    ModalLoader: ModalLoader,
    MenuBottom: MenuBottom,
    MenuMobile: MenuMobile
  },
  setup: function setup() {
    var loading = ref(false);

    var printImg = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (isCompare.value.active) {
                  isCompare.value.active = false;
                  setTimeout(function () {
                    isCompare.value.active = true;
                  }, 500);
                }

                _context.next = 3;
                return setTimeout(function () {
                  window.print();
                }, 10);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function printImg() {
        return _ref.apply(this, arguments);
      };
    }();

    var svg = "\n        <path class=\"path\" d=\"\n          M 30 15\n          L 28 17\n          M 25.61 25.61\n          A 15 15, 0, 0, 1, 15 30\n          A 15 15, 0, 1, 1, 27.99 7.5\n          L 15 15\n        \" style=\"stroke-width: 4px; fill: rgba(0, 0, 0, 0); z-index: 9999\"/>\n      ";
    var router = useRouter();
    var store = useStore();
    var colorValue = computed(function () {
      return store.getters.getwallColor;
    });
    var previousSettings = computed(function () {
      return store.getters.getPreviousSettings;
    });
    var compareFirstImage = computed(function () {
      var u;

      if (isCompare.value.mode == "LAST") {
        var _previousSettings$val, _previousSettings$val2;

        u = buildTreatedImageUrl(imgName.value, {
          color: (_previousSettings$val = previousSettings.value) === null || _previousSettings$val === void 0 ? void 0 : _previousSettings$val.color,
          floor: (_previousSettings$val2 = previousSettings.value) === null || _previousSettings$val2 === void 0 ? void 0 : _previousSettings$val2.fpatt
        });
      } else {
        u = buildTreatedImageUrl(imgName.value, {});
      }

      return u;
    });
    var floorPattern = computed(function () {
      return store.getters.getFloorPattern;
    });
    var imgName = computed(function () {
      return store.getters.getImgName;
    });
    var modifiedImage = computed(function () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      loading.value = true;
      var u = buildTreatedImageUrl(imgName.value, {
        color: colorValue.value,
        floor: floorPattern.value
      });
      var myImage = new Image();
      myImage.src = u;

      myImage.onload = function () {
        loading.value = false;
      };

      myImage.onerror = function () {
        loading.value = false;
        ElNotification({
          title: "Error",
          message: "Erreur de connexion",
          type: "error"
        });
      };

      return myImage;
    });
    var isCompare = ref({
      mode: "LAST",
      active: false
    });

    var handleCompare = function handleCompare(_ref2) {
      var mode = _ref2.mode,
          toggle = _ref2.toggle;
      if (toggle) isCompare.value.active = !isCompare.value.active;
      if (mode) isCompare.value.mode = mode;
    };

    watch(function () {
      return imgName.value;
    }, /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(imgName) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return router.push({
                  path: "/",
                  query: {
                    img: imgName.img_name
                  }
                });

              case 2:
                setWallColor("");
                setFloorPattern("");

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    return {
      handleCompare: handleCompare,
      isCompare: isCompare,
      setModal: setModal,
      imgName: imgName,
      loading: loading,
      svg: svg,
      modifiedImage: modifiedImage,
      compareFirstImage: compareFirstImage,
      printImg: printImg
    };
  }
});